var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHelpFilled = function SvgHelpFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.25c-4.825 0-8.75 3.925-8.75 8.75s3.925 8.75 8.75 8.75 8.75-3.925 8.75-8.75S14.825 1.25 10 1.25Zm-.233 13a1.02 1.02 0 0 1-1.025-1.033c-.009-.559.458-1.017 1.025-1.017a1.03 1.03 0 0 1 1.033 1.017 1.05 1.05 0 0 1-1.033 1.033Zm1.716-4.225c-.616.358-.908.708-.908 1.433v.159H8.9v-.159c0-1.375.35-1.8 1-2.208.5-.325.883-.642.892-1.142 0-.491-.4-.825-.892-.816-.483 0-.925.333-.933.908H7.158c.025-1.667 1.259-2.425 2.759-2.425 1.65 0 2.841.8 2.85 2.242 0 .966-.517 1.55-1.275 2.008h-.009Z",
    fill: "current"
  })));
};
export default SvgHelpFilled;